var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_5050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 12,
    fill: "#1877F2",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0944 31.0711C28.8228 33.3427 24.0054 35.3067 20.0956 32.8906C19.878 32.7561 19.7693 32.6889 19.687 32.6563C19.5297 32.594 19.4104 32.576 19.2418 32.589C19.1536 32.5958 19.0536 32.6217 18.8537 32.6736C17.5959 32.9996 16.967 33.1626 16.514 33.0704C15.7276 32.9103 15.113 32.2958 14.953 31.5094C14.8608 31.0563 15.0238 30.4274 15.3498 29.1696C15.4016 28.9697 15.4275 28.8697 15.4343 28.7812C15.4473 28.6126 15.4289 28.4919 15.3663 28.3347C15.3334 28.2523 15.2663 28.1442 15.132 27.9282C12.7076 24.0269 14.5839 19.2973 16.9523 16.9289C20.8575 13.0237 27.1892 13.0237 31.0944 16.9289C34.9997 20.8342 34.9997 27.1658 31.0944 31.0711Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0527 23.8574C21.0527 24.4097 20.605 24.8574 20.0527 24.8574C19.5004 24.8574 19.0527 24.4097 19.0527 23.8574C19.0527 23.3051 19.5004 22.8574 20.0527 22.8574C20.605 22.8574 21.0527 23.3051 21.0527 23.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0527 23.8574C25.0527 24.4097 24.605 24.8574 24.0527 24.8574C23.5004 24.8574 23.0527 24.4097 23.0527 23.8574C23.0527 23.3051 23.5004 22.8574 24.0527 22.8574C24.605 22.8574 25.0527 23.3051 25.0527 23.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0527 23.8574C29.0527 24.4097 28.605 24.8574 28.0527 24.8574C27.5005 24.8574 27.0527 24.4097 27.0527 23.8574C27.0527 23.3051 27.5005 22.8574 28.0527 22.8574C28.605 22.8574 29.0527 23.3051 29.0527 23.8574Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_5050",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.329412 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_5050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_5050",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportActive);
export default __webpack_public_path__ + "static/media/support-active.b8bf48567d595211bb49d2b6586b2424.svg";
export { ForwardRef as ReactComponent };